export default "__VITE_ASSET__DiLPM_Mh__"